import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas, faInfoCircle, faEdit, faTrash, faPlus, faPaperPlane } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fad } from '@fortawesome/pro-duotone-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fass } from '@fortawesome/sharp-solid-svg-icons'
/**
 * Added Solid Icons with Library
 */
library.add(fas)
library.add(far)
library.add(fab)
library.add(fass)
library.add(faInfoCircle)
library.add(faEdit)
library.add(faTrash)
library.add(faPlus)
library.add(faPaperPlane)
/**
 * To convert <i> tag to fontawesome component
 * helps with bootstrap components like datepicker
 */
// dom.watch()

/**
 * Attached fontawesome with Vue.
 */
Vue.component('font-awesome-icon', FontAwesomeIcon)